import { mount } from 'riot';
import { setError } from './services/integration';
import './views/common/errorMessage.tag';

export const handleError = (error: string | Error): void => {
  const message = error instanceof Error ? error.message : error;

  mount('error-message', { message });
  setError(message);
};
